export default {
  api_url: 'http://localhost:20080/',
  api_node_url: 'http://localhost:3000/',
};
